import '../Modal.sass'

const ModalCloseSvg = ({fill = "#546EDB"}) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="none">
            <path fill={fill} d="M14.909 1.216 9.432 6.693 3.954 1.216a1.936 1.936 0 1 0-2.738 2.738l5.477 5.478-5.477 5.477a1.936 1.936 0 1 0 2.738 2.739l5.478-5.478 5.477 5.478a1.936 1.936 0 1 0 2.739-2.74L12.17 9.433l5.478-5.478a1.936 1.936 0 1 0-2.74-2.738Z"/></svg>
    )
}

export default ModalCloseSvg;